import { ref, onMounted, onBeforeUnmount, } from 'vue';

export const useIsRetina = () => {
    const isRetina = ref(false);

    const retinaQuery = window.matchMedia('only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi)');

    const handler = () => {
        isRetina.value = retinaQuery.matches;
    };

    onMounted(() => {
        handler();
        retinaQuery.addEventListener('change', handler);
    });

    onBeforeUnmount(() => {
        retinaQuery.removeEventListener('change', handler);
    });

    return {
        isRetina,
    };
};
